<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <add-order></add-order>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Orders</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-order" v-if="user.admin">Add</button>
      </div>
      <div class="ibox-content col-lg-12">
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>

import AddOrder from './AddOrderModal'
import List from './List'
import { mapGetters } from 'vuex'

export default {
  components: {
    addOrder: AddOrder,
    list: List
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    document.title = 'Maintenance Orders :: PBN360 by Aphex Media'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Orders.vue